import { CardContent, Box, useMediaQuery, useTheme } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  content: {
    marginTop: theme.spacing(3),
  },

  graph: {
    marginTop: theme.spacing(3),
    width: "100%",
    height: 360,
    borderRadius: 12,
  },
}));

export function StepsSkeletonCard() {
  const s = useStyles();
  const { breakpoints } = useTheme();
  const isXs = useMediaQuery(breakpoints.only("xs"));

  return (
    <>
      {!isXs && (
        <CardContent
          sx={{ "&.MuiCardContent-root": { padding: "0 !important" } }}
        >
          <Box className={s.content}>
            <Skeleton animation="wave" height={24} width="30%" sx={{ mb: 3 }} />
            <Skeleton
              animation="wave"
              variant="rectangular"
              className={s.graph}
            />
          </Box>
        </CardContent>
      )}
    </>
  );
}
